import React from "react";
// Libraries
import cn from "classnames";
// Utils
import { ICON_NAMES } from "constants/Icons";
// Components
import { Icon, Text } from "components";
// Resources
import styles from "./Input.module.scss";

interface InputSharedProps {
  forceDisabledForDate?: boolean;
  hasError?: boolean;
  children?: React.ReactNode;
}

interface InputWithIconProps extends InputSharedProps {
  adornment?: never;
  icon?: {
    labelFor: string;
    name: keyof typeof ICON_NAMES;
  };
}

type InputProps = InputWithIconProps | (InputWithAdornment & InputSharedProps);

export const Input: React.FC<InputProps> = ({ children, forceDisabledForDate, hasError, icon, adornment }) => (
  <span
    className={cn(styles.input, {
      [styles["input--error"]]: hasError,
      [styles["input--has_icon"]]: icon,
      "input--force_disabled_for_date": forceDisabledForDate, // not css-modules because using it in non-`.module.scss`
    })}
  >
    {icon && (
      <label className={styles.input__icon} htmlFor={icon.labelFor}>
        <Icon colour="blue" name={icon.name} size="tiny" />
      </label>
    )}

    {children}

    {adornment && (
      <label className={styles.input__adornment} htmlFor={adornment.labelFor}>
        <Text isEllipsis smallest>
          {adornment.label}
        </Text>
      </label>
    )}

    <span className={styles.input__background} />
  </span>
);
Input.displayName = "Input";
